import { Alert, Box, List, Stack, Typography } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import Iconify from "minimals-template/components/Iconify"
import { SendToReviewScheduleRow } from "./send-to-review-schedule-row"
import { NotReadyScheduleRow } from "./not-ready-schedule-row"

export function SendToReviewDialog({ readySchedules = [], notReadySchedules = [] }) {
    const readyCount = readySchedules.length
    const notReadyCount = notReadySchedules.length
    const totalCount = readyCount + notReadyCount
    const hasReady = readyCount > 0

    return (
        <DialogBox
            title={
                <Box display="flex" alignItems="center" gap="20px">
                    <Iconify icon="mdi:send-check" />
                    <Typography variant="h5">Send to Review</Typography>
                </Box>
            }
            value={hasReady}
            okCaption={`Submit ${readyCount} of ${totalCount} Schedule${readyCount !== 1 ? "s" : ""}`}
            disabled={!hasReady}
            data-cy="send-to-review-dialog"
        >
            <Stack spacing={2} sx={{ mt: 1 }}>
                <If truthy={hasReady}>
                    <Stack spacing={1}>
                        <Typography variant="subtitle2" color="success.main" data-cy="ready-schedules-heading">
                            Ready to Submit ({readyCount})
                        </Typography>
                        <List
                            data-cy="ready-schedules-list"
                            disablePadding
                            sx={{
                                maxHeight: "20vh",
                                border: 1,
                                borderColor: "success.light",
                                borderRadius: 1,
                                overflowY: "auto",
                            }}
                        >
                            <Repeat
                                list={readySchedules}
                                item={<SendToReviewScheduleRow color="success.main" />}
                                pass="schedule"
                            />
                        </List>
                    </Stack>
                </If>

                <If truthy={notReadyCount > 0}>
                    <Stack spacing={1}>
                        <Typography variant="subtitle2" color="warning.main" data-cy="not-ready-schedules-heading">
                            Author Notes Required ({notReadyCount})
                        </Typography>
                        <List
                            data-cy="not-ready-schedules-list"
                            disablePadding
                            sx={{
                                maxHeight: "20vh",
                                border: 1,
                                borderColor: "warning.light",
                                borderRadius: 1,
                                overflowY: "auto",
                            }}
                        >
                            <Repeat list={notReadySchedules} item={<NotReadyScheduleRow />} pass="schedule" />
                        </List>
                    </Stack>
                </If>

                <Alert severity="info" sx={{ alignItems: "center" }}>
                    <If truthy={hasReady}>
                        <Typography variant="body2">
                            Submitted schedules cannot be edited until review is complete.
                        </Typography>
                        <Else>
                            <Typography variant="body2">
                                All schedules require author notes before they can be submitted. Please complete the
                                missing notes and try again.
                            </Typography>
                        </Else>
                    </If>
                </Alert>
            </Stack>
        </DialogBox>
    )
}
